import { useScreenResolution } from '@app/hooks';
import { ScrubAddressModalType } from '@app/redux/scrubbedAddress';

import SignoutButton from '../SignoutButton';
import NavBar from './NavBar';
import NavBarDropdown from './NavBarDropdown';
import { ProfileTab } from '../../types';

import styles from './styles.module.scss';

type NavigationProps = {
  currentTab: ProfileTab;
  setCurrentTab: (value: ProfileTab) => void;
  restrictSwitchTabs: boolean;
  setPendingTab: (value: ProfileTab | null) => void;
  setShowModal: (value: ScrubAddressModalType | null) => {
    payload: ScrubAddressModalType | null;
    type: 'scrubbedAddress/setShowScrubModal';
  };
};

const Navigation = ({
  currentTab,
  setCurrentTab,
  restrictSwitchTabs,
  setShowModal,
  setPendingTab,
}: NavigationProps): JSX.Element => {
  const { isMedium, isSmall, isExtraSmall } = useScreenResolution();
  const isMobile = isMedium || isSmall || isExtraSmall;

  const displayUnsavedChangesModal = (tab: ProfileTab) => {
    setPendingTab(tab);
    setShowModal(ScrubAddressModalType.Unsaved);
  };

  const handleTabClick = (tab: ProfileTab) => {
    restrictSwitchTabs ? displayUnsavedChangesModal(tab) : setCurrentTab(tab);
  };

  return isMobile ? (
    <NavBarDropdown handleTabClick={handleTabClick} currentTab={currentTab} />
  ) : (
    <div className={styles['leftSection']}>
      <NavBar handleTabClick={handleTabClick} currentTab={currentTab} />
      <hr />
      <SignoutButton />
    </div>
  );
};

export default Navigation;
